const getGenders = () => ([
  {
    value: 'male',
    label: t('genders.male', { ns: i18next.Namespace.COMMON }),
  },
  {
    value: 'female',
    label: t('genders.female', { ns: i18next.Namespace.COMMON }),
  },
  {
    value: 'non-binary',
    label: t('genders.non-binary', { ns: i18next.Namespace.COMMON }),
  },
]);

export default getGenders;
